export default __webpack_public_path__ + "static/media/error.84b76597.svg";